import React from 'react';
import { TeamSimpleVO, GroupSimpleVO } from '@src/services';
import { Link } from 'react-router-dom';
import './OrganizeLink.less';

export interface IOrganizeLinkProps {
  className?: string;
  teamInfo?: TeamSimpleVO;
  groupInfo?: GroupSimpleVO;
}
type Props = IOrganizeLinkProps;

export function OrganizeLink(props: Readonly<Props>) {
  const { className = '', teamInfo, groupInfo } = props;

  return (
    <>
      {(groupInfo?.groupId !== '0' || teamInfo?.teamId !== '0') && (
        <div className={`common-presenter k-common-organize-link ${className}`}>
          发表在&nbsp;
          {groupInfo?.groupId !== '0' ? (
            <Link className="link" to={`/group/home-page/${groupInfo?.groupId}`}>
              {groupInfo?.groupName}
            </Link>
          ) : (
            teamInfo?.teamId !== '0' && (
              <Link className="link" to={`/team/home-page/${teamInfo?.teamId}`}>
                {teamInfo?.teamName}
              </Link>
            )
          )}
        </div>
      )}
    </>
  );
}

export default OrganizeLink;
